export { QuoteRecipients } from './QuoteRecipients'
export { QUOTE_RECIPIENTS_COPY } from './quoteRecipients.constants'
